/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスキット用のS3への署名付きURLと情報
 * @export
 * @interface PressKitPresignedUrl
 */
export interface PressKitPresignedUrl {
    /**
     * 署名付きURL
     * @type {string}
     * @memberof PressKitPresignedUrl
     */
    presignedUrl: string;
    /**
     * Object key
     * @type {string}
     * @memberof PressKitPresignedUrl
     */
    objectKey: string;
}

/**
 * Check if a given object implements the PressKitPresignedUrl interface.
 */
export function instanceOfPressKitPresignedUrl(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "presignedUrl" in value;
    isInstance = isInstance && "objectKey" in value;

    return isInstance;
}

export function PressKitPresignedUrlFromJSON(json: any): PressKitPresignedUrl {
    return PressKitPresignedUrlFromJSONTyped(json, false);
}

export function PressKitPresignedUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitPresignedUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'presignedUrl': json['presigned_url'],
        'objectKey': json['object_key'],
    };
}

export function PressKitPresignedUrlToJSON(value?: PressKitPresignedUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'presigned_url': value.presignedUrl,
        'object_key': value.objectKey,
    };
}

